import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import HistoryIcon from '@material-ui/icons/History';
import MessageIcon from '@material-ui/icons/Message';
import SettingsIcon from '@material-ui/icons/Settings';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';
import ExploreIcon from '@material-ui/icons/Explore';
import PropTypes from 'prop-types';
import enhance from './SideNav.enhancer';

class NavLinkList extends React.Component {
  constructor() {
    super();

    const initialState = {
      selected: ''
    };

    this.state = {
      ...initialState
    };
  }

  componentDidMount() {
    const pathName = this.props.history.location.pathname;
    const path = pathName.substr(1, pathName.length - 1);

    this.setState({
      selected: path
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.currentPath &&
      nextProps.currentPath !== this.state.selected
    ) {
      // switch (nextProps.currentPath) {
      const currPath = nextProps.currentPath;

      if (currPath === 'messages')
        return this.setState({
          selected: 'messages'
        });
      else if (currPath === 'dashboard')
        return this.setState({
          selected: 'dashboard'
        });
      else if (currPath === 'discover-influencers')
        return this.setState({
          selected: 'discover-influencers'
        });
      else if (currPath === 'campaign/new')
        return this.setState({
          selected: 'campaign/new'
        });
      else if (currPath === 'matchFeed')
        return this.setState({
          selected: 'matchFeed'
        });
      else if (currPath === 'deals')
        return this.setState({
          selected: 'deals'
        });
      else if (currPath.includes('campaigns'))
        return this.setState({
          selected: 'campaigns'
        });
      else if (currPath === 'settings')
        return this.setState({
          selected: 'settings'
        });
      else
        return this.setState({
          selected: ''
        });
    }
  }

  handleNavigation = (url, i) => {
    if (url === 'messages') {
      this.props.resetUnreadMessagesHandler();
    }
    // need to scroll up
    this.props.history.push(`/${url}`);
    this.setState({
      selected: url
    });
  };

  render() {
    const { classes, isCompany, profile } = this.props;
    const { selected } = this.state;

    let links = [
      {
        title: 'Dashboard',
        url: 'dashboard',
        icon: <DashboardIcon />
      }
    ];

    if (profile.isCompany) {
      links = [
        ...links,
        {
          title: 'Discover Influencers',
          url: 'discover-influencers',
          icon: <ExploreIcon />
        },
        {
          title: 'Create Campaign',
          url: 'campaign/new',
          icon: <AddToQueueIcon />
        }
      ];
    } else {
      links = [
        ...links,
        {
          title: 'Discover Campaigns',
          url: 'discover',
          icon: <ExploreIcon />
        },
        {
          title: 'Campaign Invites',
          url: `matchFeed`,
          icon: <LocalOfferIcon />
        },
        {
          title: 'Deals',
          url: `deals`,
          icon: <AssignmentTurnedInIcon />
        }
      ];
    }

    if (profile.isCompany) {
      links = [
        ...links,
        {
          title: 'My Campaigns',
          url: 'campaigns',
          icon: <HistoryIcon />
        }
      ];
    }
    links = [
      ...links,
      {
        title: 'Messages',
        url: 'messages',
        icon: <MessageIcon />
      },
      {
        title: 'Account Settings',
        url: 'settings',
        icon: <SettingsIcon />
      }
    ];

    return (
      <List>
        {links.map((link, i) => (
          <ListItem
            button
            key={i}
            className={classes.listItem}
            onClick={() => this.handleNavigation(link.url, i)}
          >
            <ListItemIcon
              className={`${classes.listItem__icon} ${
                selected === link.url ? classes.listItem_active : ''
              }`}
            >
              {link.icon}
            </ListItemIcon>
            <ListItemText
              primary={link.title}
              className={`${
                selected === link.url ? classes.listItem_active : ''
              }`}
            />
          </ListItem>
        ))}
      </List>
    );
  }
}

export default enhance(NavLinkList);



// WEBPACK FOOTER //
// ./src/components/layout/NavLinkList.js